export default "__VITE_ASSET__DGRUbmzv__"